export const isDev = process.env.NODE_ENV === "development";
export const DEBUG_REDIRECT_URL = process.env.REACT_APP_DEBUG_REDIRECT_URL;
export const PFH_UUID = process.env.REACT_APP_UUID_PFH;
export const WM_UUID = process.env.REACT_APP_UUID_WALLET_MANAGER_DEV;
export const ACC_UUID = process.env.REACT_APP_UUID_ACCOUNT;
export const EURUS_UUID = process.env.REACT_APP_UUID_EURUS;
export const AUTH_UUID = process.env.REACT_APP_UUID_AUTH;
